import { render, staticRenderFns } from "./ToggleHeader.vue?vue&type=template&id=2bc8990a&scoped=true&"
import script from "./ToggleHeader.vue?vue&type=script&lang=js&"
export * from "./ToggleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ToggleHeader.vue?vue&type=style&index=0&id=2bc8990a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc8990a",
  null
  
)

export default component.exports